<template>
<div class="chapter">
<div class="inner_page">
<h2 class="partno"><a id="page_1"></a><span class="bold">Section One</span></h2>
<h2 class="parttitle"><span class="bold">The Medieval Period</span></h2>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 07_Part01.vue?611343f8